import _CK from "../utils/cookie";
import _U from "../utils/utilities";
import hostUtils from "../utils/playerUnmount";
import { resolveCanonicalEnv, CANONICAL_HOSTS } from "./environment.js";

const urlProd = "livee.kr";
const urlTest = "onoffevent.com";
const urlStage = "sharewebinar.com";

const config = {
    apiKey: "5@Q4&g28{s[CaddM(7:7#RV[",
    // tossClientKey: "live_ck_ADpexMgkW36pv92DDY4rGbR5ozO0",
    tossClientKey: "test_ck_dP9BRQmyarYaxl2nE09rJ07KzLNk",
};

config.KAKAO_API_KEY = "ad521e4f18f1309353333d753bf5da65";

const {
    isLocalDevHost,
    resolveConsoleApiHost,
    resolveConsoleWsHost,
} = hostUtils;

config.apiHost = () => {
    return resolveConsoleApiHost(window.location);
};

config.wsHost = () => {
    const authors = {
        apikey: config.apiKey,
    };
    if (_CK.isLogin()) {
        authors.authorization = _CK.getAuth();
    }

    return resolveConsoleWsHost(window.location, _U.encode(authors));
};

config.isLocal = () => {
    const { hostname } = window.location;
    switch (hostname) {
        case urlTest:
            return false;
        case urlStage:
            return false;
        case urlProd:
            return false;
        default:
            if (isLocalDevHost(hostname)) {
                return true;
            } else {
                return false;
            }
    }
};

config.hubUrl = () => {
    const { hostname } = window.location;
    const authors = {
        apikey: config.apiKey,
    };
    if (_CK.isLogin()) {
        authors.authorization = _CK.getAuth();
    }
    // 신규 canonical(.dev/.stage.livee.kr)은 기존 livee.kr 판정보다 먼저 검사해야 한다.
    const canonicalEnv = resolveCanonicalEnv(hostname);
    if (canonicalEnv) {
        return CANONICAL_HOSTS[canonicalEnv].hub;
    }
    if (isLocalDevHost(hostname)) {
        return `http://localhost:3000`;
    }else if (hostname.endsWith(urlProd)) {
        return `https://hc.livee.kr`;
    }else if (hostname.endsWith(urlTest)) {
        return `https://hub.onoffevent.com`;
    }else if (hostname.endsWith(urlStage)) {
        return `https://hc.sharewebinar.com`;
    }else {
        return `http://localhost:3000`;
    }
}

export default config;
export const ApolloOptions = () => {
    return { uri: config.apiHost() };
};
